import type {SharedBulkActionsItemPickerProps} from '@github-ui/item-picker-base/ItemPicker'
import {useListViewSelection} from '@github-ui/list-view/ListViewSelectionContext'

import type {IssueSearchType} from '../../../types/issue-search-type'
import type {ItemNodeType} from '../ListItems'
import {ListItemsHeaderWithBulkActions} from './ListItemsHeaderWithBulkActions'
import {ListItemsHeaderWithoutBulkActions} from './ListItemsHeaderWithoutBulkActions'

export type ListItemsHeaderProps = {
  checkedItems: Set<string>
  issueCount: number
  issueNodes: ItemNodeType[]
  sortingItemSelected: string
  setCheckedItems: (checkedItems: Set<string>) => void
  updateListHasPRs: (checkedSet: Set<string>) => void
  setSortingItemSelected: (sortingItemSelected: string) => void
  setCurrentPage: (page: number) => void
  useBulkActions: boolean
  listHasPRs: boolean
  isInOrganization?: boolean
  searchType?: IssueSearchType
}

export type SharedListHeaderActionProps = {
  repo: string
  owner: string
  disabled: boolean
  /**
   * Whether to render the 'Add <property>' select panel as a nested select panel (true) versus a standalone select
   * panel (false; default).
   */
  nested?: boolean
} & SharedBulkActionsItemPickerProps

export function ListItemsHeader({...props}: ListItemsHeaderProps) {
  const {anyItemsSelected} = useListViewSelection()

  if (anyItemsSelected) {
    return <ListItemsHeaderWithBulkActions {...props} />
  }

  return <ListItemsHeaderWithoutBulkActions {...props} />
}
